import React, {Component} from 'react'
import {FileTextTwoTone} from '@ant-design/icons'
class TableHead extends Component {
    render() {
        const {isFFMView = false, onOpenDescribeVariant, sizes = []} = this.props
        const isShowIcon = !!sizes && !!sizes.length && sizes.some(i => !!i && !!i._id)
        return <tr>
            <th>Size</th>
            <th>Chiều cao (cm)</th>
            <th>Chiều dài (cm)</th>
            <th>Chiều rộng (cm)</th>
            <th>Cân nặng theo thể tích (V/5) (gram)</th>
            <th>Cân nặng (gram)</th>
            <th>Cân nặng bổ sung (gram)</th>
            <th>Cập nhật</th>
            {isFFMView && <th>Giá</th>}
            <th className="text-center" colSpan={2}>
                Hành động{isShowIcon && <FileTextTwoTone style={{fontSize: 14, marginLeft: 5, cursor: 'pointer'}} onClick={onOpenDescribeVariant}/>}
            </th>
        </tr>
    }
}

export default TableHead